module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAANdJREFUaEPtl8EOwyAMQ+Gfdqr2+dNO+6f1VIlmqiLLlA719UohcewEU8vkX508/wKAqxmUGXi9P9826efykM9o97vnycHdgJEx9zwAICGzp+4noavHZowvM/D3AOJY2xLemvVovRewLE4cGj8MAMCkAgayArpXP1YiVEAeozAQKugWBAZwo7jRbPB3bjruAe4Bs+mQEBJCQnsNdPdCPCnFizH+zpNyegmZChi+XX7QDM8wCSgDcMceVgIrgZU42UpkU2b6Js4Ajl6Xx+joBLN4AMgqdPb6ChbNQECnw7ixAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/mj.png
// module id = euta
// module chunks = 0